import React from 'react';
import image1 from '../../../assets/images/home/cards/1.svg';
import image2 from '../../../assets/images/home/cards/2.svg';
import image3 from '../../../assets/images/home/cards/3.svg';
import image4 from '../../../assets/images/home/cards/4.svg';
import './Cards.scss';
import {NavLink} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import {useDispatch, useSelector} from 'react-redux';
import {setModal} from '../../../redux/actions/app/appActions';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import Count from '../../Components/Count';
import {useTranslation} from 'react-i18next';
import {hasPermission} from "../../../helpers/functions";
import {PERMISSIONS} from "../../../helpers/constants";

const Cards = ({companyList = [], projectList = []}) => {
    const profileMe = useSelector((state) => state.profile.profileMe);
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const handleShowSupportPopup = () => {
        dispatch(setModal(POPUPS.SUPPORT_POPUP));
    };

    const permissionCompany = hasPermission(PERMISSIONS.COMPANY_READ, profileMe?.permissions ?? []);

    const cards = [
        {
            title: t('SideBgItems.projects'),
            count: projectList.length,
            image: image1,
            link: mainPath.projects
        },
        ...(permissionCompany
            ? [
                {
                    title: t('SideBgItems.companies'),
                    count: companyList.length,
                    image: image2,
                    link: mainPath.companies
                }
            ]
            : []),
        {
            title: t('SideBgItems.profile'),
            count: null,
            image: image3,
            link: mainPath.profile
        },
        {
            title: t('SideBgItems.support'),
            count: null,
            image: image4,
            function: handleShowSupportPopup
        }
    ];

    return (
        <div className='card__list'>
            {cards?.map((card, idx) => {
                return (
                    <div key={idx}>
                        {card.link ? (
                            <NavLink to={card.link} className='card__item shadow'>
                                <div className='card__title'>
                                    <span>{card.title}</span>
                                    {card.count > 0 && <Count count={card.count}/>}
                                </div>
                                <div className='card__image'>
                                    <img src={card.image} alt={card.title}/>
                                </div>
                            </NavLink>
                        ) : (
                            <div onClick={handleShowSupportPopup} className='card__item shadow'>
                                <div className='card__title'>
                                    <span>{card.title}</span>
                                    {card.count > 0 && <Count count={card.count}/>}
                                </div>
                                <div className='card__image'>
                                    <img src={card.image} alt={card.title}/>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default Cards;
